import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape, listShape, recommendationShape } from '@bibliocommons/bc-prop-types';

import Divider from 'app/components/bibs/shared/Divider';
import cardShape from 'app/shapes/cardShape';
import PromoCards from './PromoCards';
import RecommendationsContainer from './Recommendations/RecommendationsContainer';
import StaffListsContainer from './StaffLists/StaffListsContainer';

import './Discover.scss';

export default class Discover extends React.PureComponent {
  render() {
    const { catalogBib, promoCards, staffLists, recommendations } = this.props;
    const metadataId = catalogBib.get('metadataId');

    const hasPromoCards = promoCards.size > 0;
    const hasRecommendations = recommendations.size > 0;
    const hasStaffLists = staffLists.size > 0;

    const hasContent = hasPromoCards || hasRecommendations || hasStaffLists;

    if (!hasContent)
      return (
        <div className="container">
          <Divider />
        </div>
      );

    return (
      <section className="cp-bib-discover">
        <div className="container">
          <StaffListsContainer metadataId={metadataId} />
          {hasRecommendations && (
            <>
              {hasStaffLists && <Divider />}
              <RecommendationsContainer />
            </>
          )}

          {hasPromoCards && (
            <>
              {(hasStaffLists || hasRecommendations) && <Divider />}
              <PromoCards promoCards={promoCards} />
            </>
          )}
        </div>
      </section>
    );
  }
}

Discover.propTypes = {
  catalogBib: catalogBibShape.isRequired,

  // Props below are used to conditionally render the divider
  promoCards: ImmutablePropTypes.listOf(cardShape).isRequired,
  staffLists: ImmutablePropTypes.listOf(listShape).isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape)
};
